// extracted by mini-css-extract-plugin
export default {"bg":"Boot_bg__T36UR","user":"Boot_user__CKlyy","loading":"Boot_loading__7LIkw","ellipsis":"Boot_ellipsis__3Awzs"};